module.exports = __webpack_public_path__ + "img/pay-yandex.4f6e32c.png";